// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"93f51742","243":"1da98fbf","310":"90cd03b5","542":"d52ad0ac","651":"b644be36","661":"c2b6f572","696":"f76c40be","950":"666669f2"}[chunkId] + ".chunk.js";
};